module.exports = __webpack_public_path__ + "img/kurume2.8e104912.jpg";